import { jsx, jsxs } from "react/jsx-runtime";
import React, { useRef } from "react";
import { c as ce, B as Box } from "./Grid-CcQKdsgp.js";
import { F as Flex } from "./Flex-BqkSIn_m.js";
import { u as useUiKitComponents } from "./useUiKitComponents-CaMIXGvd.js";
import { useBreadcrumbItem, useBreadcrumbs } from "@react-aria/breadcrumbs";
const SvgBredcrumbsArrow = (props) => /* @__PURE__ */ jsx(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 12,
    fill: "none",
    ...props,
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fill: "#fff",
        fillRule: "evenodd",
        d: "M6.957 5.293a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414-1.414L4.836 6 1.043 2.207A1 1 0 0 1 2.457.793z",
        clipRule: "evenodd"
      }
    )
  }
);
const breadcrumbItemStyles = ce({
  base: "[font-size:var(--fontSize-mobile-large-body)]  md:[font-size:var(--fontSize-desktop-large-body)] [line-height:var(--lineHeight-mobile-large-body)] md:[line-height:var(--lineHeight-desktop-large-body)] whitespace-nowrap text-[var(--colors-text-selection)] flex items-center",
  variants: {
    nonActive: {
      true: "cursor-default  text-[var(--colors-text-primary-default)] ",
      false: "cursor-pointer"
    }
  },
  defaultVariants: {
    nonActive: false
  }
});
const BreadcrumbItem = ({ ...props }) => {
  const ref = useRef(null);
  const { itemProps } = useBreadcrumbItem(props, ref);
  const { Link } = useUiKitComponents();
  return /* @__PURE__ */ jsx(Flex, { justify: "center", as: "li", children: /* @__PURE__ */ jsx(
    Link,
    {
      ref,
      ...itemProps,
      href: props.href,
      className: breadcrumbItemStyles({
        nonActive: props.variant === "disabled"
      }),
      children: props.children
    }
  ) });
};
const listStyles = ce({
  base: "flex m-0 p-0 list-none items-center flex-wrap"
});
const sectionStyles = ce({ base: "py-4 md:pt-16 md:pb-10" });
function isBreadcrumbItemElement(child) {
  return React.isValidElement(child) && child.type === BreadcrumbItem;
}
const Breadcrumbs = (props) => {
  var _a;
  const { navProps } = useBreadcrumbs(props);
  React.Children.forEach(props.children, (child) => {
    if (!isBreadcrumbItemElement(child)) {
      throw new Error("Breadcrumbs only accepts <BreadcrumbItem> as children.");
    }
  });
  const validChildren = React.Children.toArray(props.children);
  return /* @__PURE__ */ jsx(
    Box,
    {
      ...navProps,
      ...props,
      className: `${sectionStyles()} ${(_a = props == null ? void 0 : props.className) != null ? _a : ""}`,
      as: "nav",
      style: {
        ...props.style
      },
      children: /* @__PURE__ */ jsx("ol", { className: listStyles(), children: validChildren.map((child, i) => {
        var _a2;
        const isLast = i === validChildren.length - 1;
        return /* @__PURE__ */ jsxs(React.Fragment, { children: [
          React.cloneElement(child, {
            variant: (_a2 = child.props.variant) != null ? _a2 : isLast ? "disabled" : "active"
          }),
          !isLast && /* @__PURE__ */ jsx("span", { "aria-hidden": "true", className: "px-2 py-[6px]", children: /* @__PURE__ */ jsx(SvgBredcrumbsArrow, {}) })
        ] }, i);
      }) })
    }
  );
};
export {
  BreadcrumbItem as B,
  Breadcrumbs as a
};
